// extracted by mini-css-extract-plugin
export var hgwIconArrowDown = "Frontpage-module--hgwIcon-arrow-down--lepb9";
export var hgwIconArrowUp = "Frontpage-module--hgwIcon-arrow-up--1hOT8";
export var content = "Frontpage-module--content--3xRu8";
export var title = "Frontpage-module--title--3U7Do";
export var grid = "Frontpage-module--grid--1x305";
export var grid__item = "Frontpage-module--grid__item--q_ngZ";
export var linkItem = "Frontpage-module--linkItem--1CQKt";
export var linkItem__imageBox = "Frontpage-module--linkItem__imageBox--ZAJUD";
export var linkItem__textBox = "Frontpage-module--linkItem__textBox--3vAkQ";
export var cover = "Frontpage-module--cover--1cNw8";
export var coverTitle = "Frontpage-module--coverTitle--NA9r8";
export var coverBG = "Frontpage-module--coverBG--CCYZI";
export var fadeOut = "Frontpage-module--fadeOut--13CVh";
export var flag = "Frontpage-module--flag--5OGFU";
export var pages = "Frontpage-module--pages--13vqw";
export var animBarTypeA = "Frontpage-module--animBarTypeA--1RYd-";
export var animBarTypeB = "Frontpage-module--animBarTypeB--3eCV4";
export var animBarTypeC = "Frontpage-module--animBarTypeC--33zr1";
export var animBarTypeD = "Frontpage-module--animBarTypeD--2AnSH";